// EMPTY, UPDATED, DELETED, NEW

export default class TabularDatasetRow {
  get action(): string {
    let action = "";
    if (this.isEmpty()) {
      if (this.id != null) {
        action = "DELETE";
      } else {
        action = "EMPTY";
      }
    } else {
      if (this.id != null) {
        if (this._deleted) {
          action = "DELETE";
        } else if (this._updated) {
          action = "UPDATE";
        }
      } else {
        action = "INSERT";
      }
    }
    return action;
  }

  id?: number;
  parent_id: number | null = null;
  iso3: string | null = null;
  event_name: string | null = null;
  start_date: string | null = null;
  end_date: string | null = null;
  org_name: string | null = null;
  org_accuracy: string | null = null;
  org_lat: number | null = null;
  org_lon: number | null = null;
  dst_name: string | null = null;
  dst_accuracy: string | null = null;
  dst_lat: number | null = null;
  dst_lon: number | null = null;
  stock_total: number | null = null;
  stock_male: number | null = null;
  stock_female: number | null = null;
  stock_in_camp: number | null = null;
  stock_outside_camp: number | null = null;
  stock_age_cat_01: number | null = null;
  stock_age_cat_02: number | null = null;
  stock_age_cat_03: number | null = null;
  new_total: number | null = null;
  new_male: number | null = null;
  new_female: number | null = null;
  new_in_camp: number | null = null;
  new_outside_camp: number | null = null;
  new_age_cat_01: number | null = null;
  new_age_cat_02: number | null = null;
  new_age_cat_03: number | null = null;
  returns_total: number | null = null;
  returns_male: number | null = null;
  returns_female: number | null = null;
  returns_in_camp: number | null = null;
  returns_outside_camp: number | null = null;
  returns_age_cat_01: number | null = null;
  returns_age_cat_02: number | null = null;
  returns_age_cat_03: number | null = null;
  returnees_total: number | null = null;
  returnees_male: number | null = null;
  returnees_female: number | null = null;
  returnees_in_camp: number | null = null;
  returnees_outside_camp: number | null = null;
  returnees_age_cat_01: number | null = null;
  returnees_age_cat_02: number | null = null;
  returnees_age_cat_03: number | null = null;
  house_destroyed: number | null = null;
  house_damaged: number | null = null;
  url: string | null = null;
  private _updated: boolean = false;
  private _deleted: boolean = false;

  setUpdated() {
    this._updated = true;
  }

  setDeleted() {
    this._deleted = !this._deleted;
  }

  isEmpty() {
    const skip = ["id", "parent_id", "iso3", "_updated", "_deleted"];
    return Object.entries(this).reduce((empty, entry) => {
      const [key, value] = entry;
      const skipped = skip.includes(key);
      const blank = value === undefined || value == null || value === "";
      return empty && (blank || skipped);
    }, true);
  }

  isNew() {
    return !this.isEmpty() && (this.id === null || this.id === undefined);
  }

  isDeleted() {
    return this._deleted || (this.isEmpty() && this.id !== null);
  }

  isUpdated() {
    return this._updated;
  }
}
